import React from "react"
import History from "../../history/History"
import GameRules from "../../gameRules/GameRules"
import SettingsPopup from "./SettingsPopup"
import JackpotRules from "../../gameRules/JackpotRules"
// import { AppContext } from "../../../context/createContext"

export default function SettingsEach({ title, history }: any) {
  return (
    <>
      {title === "History" && (
        <SettingsPopup title="History">
          <History history={history} />
        </SettingsPopup>
      )}
      {title === "Game_Rules" && (
        <SettingsPopup title="Stellar Rules">
          <GameRules />
        </SettingsPopup>
      )}
      {title === "Jackpot_Rules" && (
        <SettingsPopup title="Jackpot Round">
          <JackpotRules />
        </SettingsPopup>
      )}
    </>
  )
}
